const toggleButtons = document.querySelectorAll('.js-toggle-subnav');

function toggleSubnav() {
    const subnav = document.querySelector('.subnav');
    subnav.classList.toggle('is-active');
}

toggleButtons.forEach(button => {
    button.addEventListener('click', toggleSubnav);
});

document.addEventListener('DOMContentLoaded', (event) => {
    const savedTheme = localStorage.getItem('bsTheme') || 'auto';
    setTheme(savedTheme);

    document.getElementById('lightTheme').addEventListener('click', () => setTheme('light'));
    document.getElementById('darkTheme').addEventListener('click', () => setTheme('dark'));
    document.getElementById('autoTheme').addEventListener('click', () => setTheme('auto'));
});

function setTheme(theme) {
    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem('bsTheme', theme);
    applyPrefersColorScheme();
}

function applyPrefersColorScheme() {
    if (localStorage.getItem('bsTheme') === 'auto') {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            document.documentElement.setAttribute('data-bs-theme', 'dark');
        } else {
            document.documentElement.setAttribute('data-bs-theme', 'light');
        }
    }
}

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
    if (localStorage.getItem('bsTheme') === 'auto') {
        setTheme('auto');
    }
});
